export function getAppTokenHeaders(): Record<string, string> {
    const token = process.env.REACT_APP_APP_TOKEN || "";
    if (!token) return {};
    return {"x-app-token": token};
}
